// 客户
<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="订单管理">
        <span slot="label"><i class="iconfont icon-sale-order" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_sales_order")}}</span>
        <GuestCustOrder></GuestCustOrder>
      </el-tab-pane>
      <el-tab-pane label="库存导入">
        <span slot="label"><i class="iconfont icon-inventory" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_inventory_import")}}</span>
        <GuestVendInventSum :export_type="'cust'" :is_pub="true"></GuestVendInventSum>
      </el-tab-pane>
      <el-tab-pane label="库存导入查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_inventory_import_search")}}</span>
        <GuestCustInventSumSearch></GuestCustInventSumSearch>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import GuestCustOrder from "./GuestCustOrder";
import GuestVendProductionCapacity from "../fi/ProductionCapacityExport"
import GuestCustInventSumSearch from "./GuestCustInventSumSearch"
import GuestVendInventSum from "../wm/InventSumExport";


export default {
  name: "GuestCust",
  components: {
    GuestCustOrder,
    GuestVendProductionCapacity,
    GuestVendInventSum,
    GuestCustInventSumSearch
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>


